export const environment = {
    production: true,
    name: 'staging',
    overwritePhoneRegex: '',
    enableSharedTimer: true,
    resetTimerWhenSubmit: true,
    hiddenPhoneNumbers: 0.5,
    newOtpOnSmsWaitTime: 90,
    newOtpOnEmailWaitTime: 90,
    OtpGwBaseUrl: 'https://spid-dev.teamsystem.com/otpgw',
    showAuthenticationWithApp: true,
};
